/**
 * The stable DOM id of the in-content ad container.
 *
 * Mediavine's Journey scanner places in-content units between the DIRECT
 * CHILDREN of whatever the dashboard's `content_selector` matches
 * (`enable_divbuster` is false, so it never descends further). That selector
 * was a Tailwind class chain for the first year of the program, and it broke
 * twice without any error surfacing: once when their ops rewrote it
 * (2026-08-21, `article.relative .px-0 > .relative` -> `article
 * .prose-lede-host`), and once when our own markup moved the marked class to a
 * single prose segment and capped long posts at one unit (2026-09-13).
 *
 * This id exists so the dashboard selector can be `#wgis-post-body`: one
 * string, greppable, that no styling change can move. It goes on the element
 * that is the DIRECT PARENT of the prose blocks, and on exactly one element
 * per page.
 *
 * Renaming it is a live ad-serving change. The dashboard selector has to
 * change in the same window or every long-form route serves zero in-content
 * units.
 */
export const AD_CONTENT_ROOT_ID = "wgis-post-body"
